/**
 @author xiaoye
 @date 2020/4/10 7:53 下午
 */

import store from '@/store';
import Vue from 'vue'
import {comLegend, comColor} from "../../script/comChart";
import jsonVal from "./json/data.json";

let vm = new Vue();
let vuex = store.state;
export default {
    //类型
    type: 'gauge',
    //类别
    class: 'chart',
    //组件名称
    name: '仪表盘',
    //排序
    sort: 6,
    //是否在多维分析展示
    viewType:true,
    //图标
    iconImg: '/img/gauge.png',
    //基础配置
    option: {
        //最小维度数量
        minWDLength: 0,
        //最小度量数量
        minDLLength: 1,
        //最大维度数量
        maxWDLength: 0,
        //最大度量数量
        maxDLLength: 1,
        //高
        dp_height: 200,
        //宽
        dp_wight: 300,
        //最小高
        dp_min_height: 50,
        //最小宽
        dp_min_wight: 50,
        //是否展示维度配置
        isWdConfig: true,
        //是否展示度量配置
        isDlConfig: true,
        //是否展示JSON配置
        isJSONConfig: true,
        //是否展示公共配置
        isComConfig: true,
        //是否展示边框
        isComBorder: true,
    },
      // 子集展示的配置项
    chilCharts: [
        {
            name: '仪表盘',
            ordImg: '/img/gauge.png',
            bigImg: '/img/gauge.png',
            //默认配置
            chartParam: {},
            wdParam: {},
            dlParam: {
                stack: ''
            },
            //提示
            viewDpPrompt: '值只能是一个且必须是数字类型',
        }
    ],
    //维度组件
    wdComponent: null,
    //维度参数
    wdHandle(option) {
        return {}
    },
    //度量组件
    dlComponent:  null,
    //度量参数
     //度量参数
    dlHandle(option) {
        return {
            //堆叠
            stack: '',
            //颜色
            color: '',
            //自定义
            customColor: false,
            //数值
            label: {
                show: false,
            },
            //主次轴
            lTAxis: 0,
        }
    },
    //配置参数
    params(option) {
        return {
            gauge:{
                total:'100',
                radius:'100',
                startAngle:'225',
                endAngle:'-45',
                splitNumber:5,
                color:'auto',
                changeBool:false,
                //仪表盘轴线相关配置。
                axisLine:{
                    show: true,
                    lineStyle: {
                        color:[[0.2, 'red'], [0.4, 'yellow'], [0.6, 'yellow'],[0.8, 'yellow'],[1, 'blue']],
                        width: 20,
                    }
                },
                //分隔线
                splitLine: {
                    show: true ,
                    length: 30 ,
                    lineStyle: {
                        color:' #eee' ,
                        width: 2 ,
                        type: 'solid',
                    }
                },
                //刻度线
                axisTick: {
                    show: true ,
                    splitNumber: 10,
                    length: 8 ,
                    lineStyle: {
                        color:' #eee' ,
                        width: 1,
                        type: 'solid',
                    }
                },
                axisLabel: {
                    show: true ,
                    distance: 0 ,
                    color: vuex.dpType === 1 ? '#fff' : '#333',
                    fontSize: 12 ,
                },
                title: { //标题
                    show: true,
                    offsetCenter: [0, -25], // x, y，单位px
                    textStyle: {
                        color: vuex.dpType === 1 ? '#fff' : '#333',
                        fontSize: 14, //表盘上的标题文字大小
                    }
                },
                detail: {
                    show:true,
                    color: vuex.dpType === 1 ? '#fff' : '#333',
                    offsetCenter: [0, 38],
                    fontSize: 18 ,
                    formatter: '{value}%'
                },
                pointer: {
                    show: true,
                    length:80,
                    width: 8,
                },
            }
        }
    },
    //右侧图表配置组件列表
    configModule: [
        {
            name: '仪表盘配置',
            component: () => import('./config/gauge_config.vue')
        },
    ],
    //接口
    JSONData: {
        //静态数组
        listDaVal: jsonVal,
        //接口参数
        params: {
            //维度
            wd: ['维度'],
            //度量
            dl: ['度量1']
        },
        //引用的组件
        jsonPonent: () => import('./json/json'),
    },
    //静态转换数据回调
    JSONRender(json, chart, nowChart, viewDP) {
        try {
            let setChart = chart.setting;
            let params = nowChart.comParam.JSONData.params;
            let dl = params.dl;
            let dlStyParam = setChart.dlStyParam;
            let head = {
                listWD: [],
                listZB: []
            };

            let dt = JSON.parse(json);
            dl.map((item, index) => {
                if (!item) {
                    return;
                }
                let count = 0;
                for (let i of setChart.dlList) {
                    if (i.name === item) {
                        count = 1;
                        break;
                    }
                }
                head.listZB.push({
                    alias: item,
                    filed: item
                });
                if (count === 0) {
                    let data = {
                        name: item,
                        config: JSON.parse(JSON.stringify(viewDP.comDLConfig)),
                        params: JSON.parse(JSON.stringify(dlStyParam[index] || nowChart.comPonent.dlParams))
                    };
                    data.config.alias = item;
                    setChart.dlList.push(data)
                }
            });
            let JkData = {
                dataTabel: {
                    dt: dt,
                    head: head
                },
                totalCount: dt.length
            };
            chart.data = JkData;
        } catch (e) {
            chart.data = {};
        }
    },
    renderBefore(chart, nowChart,dom) {
        let echart = echarts.init(dom);
        echart.dispose()
        echart = null;
        nowChart.comConfig.gridType = 1;
    },
    //渲染
    rendering(chart, nowChart, dom) {
        let dataAll = JSON.parse(JSON.stringify(chart.data.dataTabel));
        //度量维度配置
        let config = chart.setting;
        // 图表轴
        let comConfig = nowChart.comConfig;
        let echart = echarts.init(dom);
        let params = config.params;
        // 维度配置参数
        let wdParams = config.wdList;
        // 度量配置参数
        let dlParams = config.dlList;
        //维度名称
        let wd = dataAll.head.listWD;
        //度量
        let dl = dataAll.head.listZB;
        //颜色
        let colorList = JSON.parse(JSON.stringify(comColor(comConfig.colorIndex)));
        //数据
        let dataVal = dataAll.dt;

        dataVal.map((item, index) => {
            let da = {};
            for (let i in item) {
                da[i.toLowerCase()] = item[i];
            }
            dataVal[index] = da;
        });
        //
        let legendList = [];

        if (dataAll.dt.length > comConfig.valLength) {
            dataAll.dt.length = nowChart.comConfig.valLength;
        }

        //获取度量数据
        let dlVal = [];
        dl.map((i, index) => {
            let configDL = {};
            dlParams.map((c) => {
                if (c.name === i.filed) {
                    configDL = c;
                }
            });
            let node = {
                value: [],
                filedNmae: i.filed,
                aliasNmae: i.alias,
                config: configDL,
            };
            node.value = dataVal.map((item) => {
                if (configDL.params.customColor) {
                    colorList[index] = configDL.params.color;
                    return {
                        itemStyle: {
                            color: configDL.params.color
                        }
                    } || 0
                } else {
                    return item[i.alias] || 0
                }
            });
           
            dlVal.push(node);
            legendList.push(i.alias);
        });
        //判断数据是否超过15条  grid专用
        let isDataLengthToNum = function () {
            let min = 15;
            if (!dataAll.dt) return false;
            if (dataAll.dt.length > min) {
                return true;
            } else {
                return false;
            }
        };
        let option = {
            tooltip: {
                trigger: 'item',
                axisPointer: {
                    label: {
                        show: true
                    }
                }
            },
            grid: {
                top: comConfig.grid.top + '%',
                bottom: comConfig.grid.bottom + '%',
                left: comConfig.grid.left + '%',
                right: comConfig.grid.right + '%',
                containLabel: true
            },
            // legend: comLegend(params.legend, legendList),
            color: colorList,
            series: (() => {
                let list = [];
                let value;
                let gauge = params.gauge;
                let dlParam = dlVal[0].config.params;
                let colorArr=[];
                let  idx = 1/gauge.splitNumber;
                if(dlVal[0].value.length===1 && typeof dlVal[0].value[0] === 'number'){
                    if(gauge.changeBool){
                        value=dlVal[0].value[0] / gauge.total * 100 ;
                        value = value.toFixed(2);
                    }else{
                        value=80;
                        gauge.total = dlVal[0].value[0] / (value /100) ;
                    }
                    for(let i=0;i<gauge.splitNumber;i++){
                        if(i<10){
                            colorArr.push([idx*(i+1),colorList[i]]);
                        }else{
                            colorArr.push([idx*(i+1),colorList[9]]);
                        }
                    }
                    gauge.axisLine.lineStyle.color=colorArr;
                }else{
                    value = NaN;
                }
                list.push({
                    type:this.type,
                    data: [{value: value, name: dlVal[0].aliasNmae}],
                    radius:gauge.radius+ '%',
                    startAngle: gauge.startAngle ,
                    endAngle: gauge.endAngle,
                    splitNumber:Number(gauge.splitNumber),
                    pointer: {
                        show: gauge.pointer.show,
                        length:gauge.pointer.length + '%',
                        width:gauge.pointer.width,
                    },
                    //指针样式
                    itemStyle: {
                        color: gauge.color,
                    },
                    //仪表盘轴线相关配置。
                    axisLine:gauge.axisLine,
                    //刻度线
                    axisTick: gauge.axisTick,
                    //分割线
                    splitLine:gauge.splitLine,
                    axisLabel: gauge.axisLabel,
                    title: gauge.title,
                    center: [comConfig.circle.left + '%', comConfig.circle.top+ '%'],
                    detail:gauge.detail,

                });

                return list;
            })()
        };
        echart.clear();
        echart.setOption(option);
        echart.resize();
    }
}